import { CenterMessage } from "../../components/CommonElements";

const TemplateUnavailable = () => {
  return (<CenterMessage message="Template is no longer available" />);
};

export { TemplateUnavailable }